import { useEffect, useState } from 'react';
import apis from '@src/apis';
import { dateInLastDays } from '@src/services/leaderboard';

const useCheckEvent = () => {
  const [dataEvent, setDataEvent] = useState();
  const [loading, setLoading] = useState();

  const eventShow = dataEvent?.previousEvent;
  const displayDurationDays = Math.max(
    ...(eventShow?.prizes?.trending || []).map(
      (item) => item?.badge?.displayDurationDays,
    ),
    ...(eventShow?.prizes?.emerging || []).map(
      (item) => item?.badge?.displayDurationDays,
    ),
  );

  const fetchLeaderboard = async () => {
    setLoading(true);
    const data = await apis.leaderboard.getLeaderboard();
    if (data?.status) {
      setDataEvent(data.result);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  // Condition to determine whether to display the Leaderboard button:
  // If there are no current or next events, or only the previous event exists and it's not within the recent displayDurationDays.
  const { currentEvent, nextEvent, previousEvent } = dataEvent || {};

  // Check for null to ensure data has been fetched
  const hasNoCurrentEvent = currentEvent === null;
  const hasNoNextEvent = nextEvent === null;
  const hasNoPreviousEvent = previousEvent === null;

  const isPreviousEventOutOfRange =
    previousEvent &&
    !dateInLastDays(previousEvent.endDate, displayDurationDays);

  const eventInvalid =
    hasNoCurrentEvent &&
    hasNoNextEvent &&
    (hasNoPreviousEvent || isPreviousEventOutOfRange);

  return eventInvalid || loading !== false;
};

export default useCheckEvent;
